import React, { Component } from 'react'
import Highcharts from 'highcharts'
import { BAR_CHART_COLORS } from '../../Helpers/ChartConstants.js'
import { formatDateStandard } from '../../../../global/formatters/string-formatter.js'

class PerformanceGrowthOf10k extends Component {
  constructor(props) {
    super(props)
  }

  componentDidMount() {
    this.renderAreaChart(this.props.data)
  }

  componentDidUpdate() {
    this.renderAreaChart(this.props.data)
  }

  renderAreaChart(data) {
    const hasValues =
      data &&
      data.value &&
      data.value.product &&
      data.value.product.perfDetails &&
      data.value.product.perfDetails.length > 0

    if (!hasValues) {
      // don't render chart if there aren't any values provided.
      return
    }

    const chartSeriesData = [
      {
        data: this.getIndexFundData(
          data.value.product.perfDetails,
          'fundWeight'
        ),
        name: data.value.product.fundName + ' NAV',
        type: 'area',
      },
    ]

    chartSeriesData.push({
      data: this.getIndexFundData(
        data.value.product.perfDetails,
        'indexWeight'
      ),
      name: data.value.product.index,
      type: 'line',
    })

    Highcharts.setOptions({
      lang: {
        thousandsSep: ',',
      },
    })

    Highcharts.chart('growth-of-10k-chart', {
      chart: {
        spacing: [10, 0, 10, 0],
        style: {
          fontFamily: 'Roboto Condensed',
          fontSize: '16px',
        },
      },
      colors: BAR_CHART_COLORS,
      credits: false,
      plotOptions: {
        area: {
          fillOpacity: 1,
          lineWidth: 0,
          states: {
            hover: { lineWidthPlus: 0 },
          },
        },
        series: {
          marker: {
            enabled: false,
          },
        },
      },
      legend: {
        itemMarginBottom: 5,
        itemStyle: {
          color: 'rgb(35, 31, 32)',
          fontSize: '16px',
          lineHeight: '1em',
        },
        margin: 10,
        symbolPadding: 4,
        symbolHeight: 12,
        symbolRadius: 12,
      },
      series: chartSeriesData,
      title: {
        text: '',
      },
      tooltip: {
        backgroundColor: 'rgba(255,255,255, 0.95)',
        borderColor: 'rgba(35, 31, 32, 0.3)',
        borderRadius: 5,
        footerFormat: '</table>',
        headerFormat:
          '<h4 class="u-marginBottom2gu">{point.key:%m/%d/%Y}</h4>' +
          '<table class="Table" style="width: 300px;">',
        padding: 10,
        pointFormat:
          '<tr class="Table-row" style="background-color: transparent;">' +
          '<td class="Table-cell u-paddingBottom0 u-paddingLeft0 u-paddingRight0 u-paddingTop2gu u-textTight" style="width: 10px;">' +
          '<hr class="Bullet" style="color: {series.color};">' +
          '</td>' +
          '<td class="Table-cell u-paddingBottom0 u-paddingLeft1gu u-paddingRight4gu u-paddingTop2gu u-textTight">' +
          '{series.name}' +
          '</td>' +
          '<td class="Table-cell u-paddingBottom0 u-paddingHoriz0 u-paddingTop2gu u-textRight u-textTight">' +
          '${point.y:,.0f}' +
          '</td>' +
          '</tr>',
        shadow: false,
        shared: true,
        useHTML: true,
      },
      xAxis: {
        crosshair: {
          enabled: true,
          zIndex: 1,
        },
        endOnTick: false,
        labels: {
          style: {
            color: 'rgba(35, 31, 32, 0.60)',
            fontSize: '14px',
          },
        },
        lineWidth: 0,
        maxPadding: 0,
        minPadding: 0,
        tickWidth: 0,
        startOnTick: false,
        type: 'datetime',
      },
      yAxis: {
        labels: {
          style: {
            color: 'rgba(35, 31, 32, 0.60)',
            fontSize: '14px',
          },
        },
        gridLineColor: 'rgba(35, 31, 32, 0.10)',
        lineWidth: 0,
        minorTicks: true,
        title: '',
      },
    })
  }

  getIndexFundData(perfDetailsArray, type) {
    const chartDataArray = []

    perfDetailsArray.map((performanceData) => {
      const timeInMillis = new Date(performanceData.asOfDate).getTime()
      const value = performanceData[type]
      let plotData

      if (value) {
        plotData = [timeInMillis, parseFloat(value.replace(/,/g, ''))]
      } else {
        plotData = [timeInMillis, parseFloat(0)]
      }

      chartDataArray.push(plotData)
    })

    return chartDataArray
  }

  render() {
    return (
      <div className="Content u-paddingBottom4gu" id="growth-of-10k">
        <h3>
          Growth of a $10,000 Investment{' '}
          <span className="u-sm-block u-sm-paddingTop1gu">
            as of {formatDateStandard(this.props.data.value.product.asOfDate)}
          </span>
        </h3>
        <div id="growth-of-10k-chart"></div>
      </div>
    )
  }
}

export default PerformanceGrowthOf10k
